import React, { ChangeEvent, useState } from "react";
import Scaffold from "../../../../Components/Scaffold";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useGetRolesQuery } from "../../../../hooks/AdminManagement/useGetRolesQuery";
import { useAddAdminMutation } from "../../../../hooks/AdminManagement/useAddAdminMutation";
import { Link } from "react-router-dom";
import { HexColorPicker } from "react-colorful";

type Props = {};

interface Items {
  name: string;
  description: string;
  permission?: (string | null)[] | null;
  id: string;
}

const AdminForm = (props: Props) => {
  const [payload, setPayload] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    colorCode: "",
    role: "",
    phoneNumber: "",
    phoneCountryCode: "",
  });

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const { data: roles } = useGetRolesQuery();
  const { mutateAsync } = useAddAdminMutation();

  const handleSubmit = () => {
    mutateAsync(payload);
  };

  return (
    <div className="px-4">
      <div className="max-w-[486px] mx-auto mt-[30px] border-[1px] border-[#eeeeee] rounded-[10px]">
        <Scaffold left="Create An Admin">
          <div className="border-t-[#eeeeee] border-r-[#fff] border-l-[#fff] border-[1px] border-b-[#eeeeee] px-[20px] py-[10px] text-[#a8a8a8]">
            Admin Details
          </div>
          <div className="flex gap-[10px] px-[20px]">
            <div className="w-6/12">
              <label htmlFor="firstName" className="mt-[20px]">
                First Name
              </label>
              <input
                name="firstName"
                type="text"
                placeholder="First Name"
                className="px-[15px] w-full mb-[21px] py-[20px] border-[1px] border-[#d3d3d3] mt-[13px] rounded-md"
                value={payload?.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div className="w-6/12">
              <label htmlFor="lastName" className="mt-[20px]">
                Last Name
              </label>
              <input
                name="lastName"
                type="text"
                placeholder="Last Name"
                className="px-[15px] mb-[21px] py-[20px] border-[1px] border-[#d3d3d3] mt-[13px] w-full rounded-md"
                value={payload?.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="px-[20px]">
            <label htmlFor="email" className="mt-[20px]">
              Enter Email Address
            </label>
            <input
              name="email"
              type="text"
              placeholder="Enter email"
              className="px-[15px] mb-[21px] py-[20px] border-[1px] border-[#d3d3d3] mt-[13px] w-full rounded-md"
              value={payload?.email}
              onChange={handleInputChange}
            />
          </div>
          {/* <div className="px-[20px]">
            <label htmlFor="password" className="mt-[20px]">
              Password
            </label>
            <input
              name="password"
              type="password"
              placeholder="**********"
              className="px-[15px] w-full mb-[21px] py-[20px] border-[1px] border-[#d3d3d3] mt-[13px] rounded-md"
              value={payload?.password}
              onChange={handleInputChange}
            />
          </div> */}
          <div className="px-[20px]">
            <label htmlFor="phoneNumber" className="mt-[20px]">
              Enter Phone Number
            </label>
            <PhoneInput
              defaultCountry="ng"
              className="mt-[13px]"
              name="phoneNumber"
              value={payload?.phoneNumber}
              onChange={(phone, country) => {
                setPayload({
                  ...payload,
                  phoneNumber: phone,
                });
              }}
            />
          </div>
          <div className="border-t-[#eeeeee] border-r-[#fff] border-l-[#fff] border-[1px] border-b-[#eeeeee] px-[20px] py-[10px] text-[#a8a8a8]">
            Role Assignment
          </div>
          <div className="px-[20px] mt-[20px]">
            <label htmlFor="role" className="">
              Select Role
            </label>
            <select
              name="role"
              onChange={handleInputChange}
              className="px-[15px] mb-[21px] py-[20px] border-[1px] border-[#d3d3d3] mt-[13px] w-full rounded-md"
              value={payload.role}
            >
              <option value="" disabled>
                --Select Role--
              </option>
              {roles?.data &&
                roles?.data.map((item: Items) => (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="mx-[20px]">
            <button
              onClick={handleSubmit}
              disabled={
                !payload?.email ||
                !payload?.firstName ||
                !payload?.lastName ||
                !payload?.phoneNumber ||
                !payload?.role
              }
              className={`rounded-[8px]  p-[22px] text-white my-[20px] w-full ${
                !payload?.email ||
                !payload?.firstName ||
                !payload?.lastName ||
                !payload?.phoneNumber ||
                !payload?.role
                  ? "bg-[#562B00]"
                  : "bg-orange"
              }`}
            >
              Complete
            </button>
          </div>
        </Scaffold>
      </div>
    </div>
  );
};

export default AdminForm;
